import { render, staticRenderFns } from "./UserGeneralTab.vue?vue&type=template&id=cbfe3cc2&scoped=true"
import script from "./UserGeneralTab.vue?vue&type=script&lang=js"
export * from "./UserGeneralTab.vue?vue&type=script&lang=js"
import style0 from "./UserGeneralTab.vue?vue&type=style&index=0&id=cbfe3cc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfe3cc2",
  null
  
)

export default component.exports